import {
  REORDER_AREA_ENTRY_STRATEGY,
  REORDER_AREA_ENTRY_STRATEGY_FAILED,
  REORDER_AREA_ENTRY_STRATEGY_SUCCESSFUL,
} from './actionTypes';

export const reorderAreaEntryStrategy = ({ token, updatedBy, strategyId, areas, history }) => ({
  type: REORDER_AREA_ENTRY_STRATEGY,
  payload: { token, updatedBy, strategyId, areas, history },
});

export const reorderAreaEntryStrategySuccessful = (message) => ({
  type: REORDER_AREA_ENTRY_STRATEGY_SUCCESSFUL,
  payload: message,
});

export const reorderAreaEntryStrategyFailed = (error) => ({
  type: REORDER_AREA_ENTRY_STRATEGY_FAILED,
  payload: error,
});
